<template>
    <div>
      <div class="row mt-3">
        <div class="col">
          <h4 class="mb-2 fs-16 dkl-h4">Comments</h4>

          <div class="d-flex mt-3 p-1" v-for="comment in commentObject.comments" :key="'comment-' + comment.id">
            <div class="flex-grow-1">
              <h5 class="mt-0 mb-0 fs-14">
                <span class="float-right text-muted fs-12">{{comment.modified}}</span>{{comment.modified_by}}
              </h5>
              <p class="mt-1 mb-0 text-muted">
                <a href="#" title="Delete" class="btn btn-link text-danger btn-lg p-0 float-right" @click.prevent="deleteComment(comment.id)">
                  <i class="fa fa-trash"  :data-comment-id="comment.id"></i>
                </a>
                {{comment.comment}}
              </p>
            </div>
          </div> <!-- end comment -->

          <hr />

        </div> <!-- end col -->
      </div> <!-- end row -->

      <div class="row mt-1">
        <div  v-if="commentObject.id && edit" class="col">
          <div class="border rounded">
            <textarea rows="3" class="form-control border-0 resize-none" placeholder="neue Bemerkungen..." v-model="newComment"></textarea>
            <div class="p-2 bg-light">
              <div class="float-right">
                <button type="button" class="btn btn-sm btn-success" @click="saveComment">
                  <i class='uil uil-message me-1'></i>kommentieren
                </button>
              </div>
            </div>
          </div> <!-- end .border-->
        </div> <!-- end col-->
        <div  v-else class="col">
          <p>Kommentieren ist nur möglich wenn der neue {{ modelVerboseName }} gespeichert ist!</p>
        </div>
      </div> <!-- end row-->
    </div>
</template>

<script>
  import {mapState} from 'vuex';
  import service from '@/utils/request.js';
  import Vue from "vue";
  import store from "@/store";
    export default {
      name: "commentComponent",
      props: {
        commentObject: {
          type: Object,
          required: true,
          default: () => {
            return {
              id: null,
              comments: [],
            }
          }
        },
        modelName: {
          type: String,
          required: true
        },
        modelVerboseName: {
          type: String,
          default: 'Eintrag'
        }
      },
      data() {
        return {
          newComment: ''
        }
      },
      computed: {
        ...mapState({user: state => state.user, account: state => state.account, edit: state => state.app.edit}),
      },
      methods: {
        saveComment() {
          service.request({
            url: 'todos/v1/save_comment/',
            method: 'post',
            data: {modified_by: this.user.username, model: this.modelName, object_id: this.commentObject.id, comment: this.newComment},
            responseType: 'json',
            contentType: 'application/json',
          }).then((response) => {
            this.commentObject.comments.push(response.data)
            this.$emit('commentUpdated', this.commentObject)
          })
        },
        deleteComment(commentID) {
          this.$confirm(
            {
              message: `Sind Sie sicher, diesen Eintrag zu löschen?`,
              button: {
                no: 'Nein',
                yes: 'Ja'
              },
              callback: confirm => {
                if (confirm) {
                  store.commit('SET_MODALDIRTY', false)
                  $(modalObject).modal('hide')
                }
              }
            }
          )
          service.request({
            url: `todos/v1/delete_comment/${commentID}/`,
            method: 'DELETE',
            responseType: 'json',
          }).then((response) => {
            const commentIndex = this.commentObject.comments.findIndex((comment) => comment.id === commentID)
            this.commentObject.comments.splice(commentIndex, 1)
            this.$emit('commentUpdated', this.commentObject)
          })
        },
      }
    }
</script>

<style scoped>

</style>
